import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserChatCrm, inicializarChatCrm } from '../interfaces/userchatcrm';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { MessageService } from 'primeng/api';  // Importamos el servicio de mensajes
import { LanguageService } from './language.service';


@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private userChatCrm: BehaviorSubject<UserChatCrm>;
  private restorePasswordSubject = new BehaviorSubject<boolean | undefined>(undefined);
  private _fechaObservable: Observable<Date>;
  private tiempoInactividad: any;
  private tiempoMaximoInactividad = 20 * 60 * 1000; 

  private baseApi = environment.baseApi;
  private inactivityWarningAlert: any; // Solo para la alerta de "sesión por expirar"
  constructor(private http: HttpClient, private router: Router, private languageService: LanguageService) {
    const user = localStorage.getItem('userChatCrm');
    this.userChatCrm = new BehaviorSubject<UserChatCrm>(user == null ? inicializarChatCrm : JSON.parse(user));
    

    this._fechaObservable = new Observable(observer => {
      setInterval(() => {
        const fecha = localStorage.getItem("fecha-expiracion");
        if (fecha) {
          observer.next(new Date());
        }
      }, 15000);
    });

    this.iniciarTemporizadorInactividad();
  }

  async userLogin(body: any) {
    return this.http.post<any>(`${this.baseApi}/login`, body).toPromise()
      .then(response => {
        localStorage.setItem('token', response.data.token);
        this.ingresarUsuario(response.data.user);
        return response.data;
      });
  }

  compararTiempoSesion(fechaActual: Date) {
    const fechaLocalStorage = localStorage.getItem('fecha-expiracion');
    if (!fechaLocalStorage) return;

    const fechaExpiracion = new Date(fechaLocalStorage);
    if (fechaActual > fechaExpiracion) {
      this.cerrarSesionPorInactividad();
    }
  }

  // 🔹 Cerrar sesión por inactividad
  private cerrarSesionPorInactividad() {
    this.cerrarSesion(true); // Mostrar alerta solo en inactividad
  }

  // 🔹 Cerrar sesión (solo muestra alerta si es por inactividad)
  cerrarSesion(mostrarAlerta: boolean = false) { 
  this.closeInactivityWarningAlert();
  
    localStorage.removeItem("userChatCrm");
    localStorage.removeItem("token");
    localStorage.removeItem("fecha-expiracion");
    const lang = this.languageService.getLanguage();

    this.router.navigateByUrl(`/welcome?lang=${lang}`)
    .then(() => {
      if (mostrarAlerta) {
        this.mostrarAlertaSesionExpirada();
      }
    });
  }

  // 🔹 Mostrar alerta de sesión expirada
  private mostrarAlertaSesionExpirada() {
    Swal.fire({
      title: this.languageService.translateInstant('SESSION_EXPIRED'),
      text: this.languageService.translateInstant('LOGIN_AGAIN'), 
      icon: 'warning',
      confirmButtonText: 'OK'
    });
  }

  // 🔹 Iniciar el temporizador de inactividad
  iniciarTemporizadorInactividad() {
    this.resetearTemporizador();
    window.addEventListener('mousemove', () => this.resetearTemporizador());
    window.addEventListener('keydown', () => this.resetearTemporizador());
    window.addEventListener('click', () => this.resetearTemporizador());
  }

  // 🔹 Resetear temporizador de inactividad
  private resetearTemporizador() {
    // Limpiar cualquier temporizador anterior
    clearTimeout(this.tiempoInactividad);
    const nuevaFechaExpiracion = new Date(new Date().getTime() + this.tiempoMaximoInactividad);
    console.log('Nueva fecha de expiración calculada: ', nuevaFechaExpiracion);
    localStorage.setItem('fecha-expiracion', nuevaFechaExpiracion.toString());
  
    // Reiniciar el temporizador para la sesión de inactividad
    this.tiempoInactividad = setTimeout(() => {
      this.cerrarSesionPorInactividad(); // Ejecutar la función de cerrar sesión
    }, this.tiempoMaximoInactividad);
  }
  

  ingresarUsuario(user: any) {
    localStorage.setItem("userChatCrm", JSON.stringify(user));
    this.userChatCrm.next(user);
    this.restorePasswordSubject.next(user.passwordRestore);
  }

  get chatCrmUser(): UserChatCrm {
    return this.userChatCrm.value;
  }

  get restorePassword$() {
    return this.restorePasswordSubject.asObservable();
  }

  get fechaObs() {
    return this._fechaObservable;
  }
 
setInactivityWarningAlert(alert: any): void {
  this.inactivityWarningAlert = alert;
}

// Cierra solo la alerta de advertencia
closeInactivityWarningAlert(): void {
  if (this.inactivityWarningAlert) {
    this.inactivityWarningAlert.close();
    this.inactivityWarningAlert = null;
  }
}
}
